module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_9006.89cdcf1c.png";